angular.module('bmsApp.fees')
	.controller('DeductionsModalCtrl', DeductionsModalCtrl);

DeductionsModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$timeout',
	'fee',
	'$modalInstance',
	'TaxHelperSvc',
	'Upload',
];

function DeductionsModalCtrl($scope, $state, $q, $timeout, fee, $modalInstance, TaxHelperSvc, Upload) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		breakdown: {},
	});

	handlers.onInit = () => {
		self.fee = fee;
		if (!angular.isArray(self.fee.expenses)) {
			angular.extend(self.fee, {
				expenses: [],
			});
		}
	};

	handlers.onCancel = () => {
		$modalInstance.dismiss('cancel');
	};

	handlers.addDeduction = () => {
		self.fee.expenses.push({});
	};

	handlers.onNetUpdated = (expense) => {
		TaxHelperSvc.setVatRate()
			.then(function () {
				expense.total_vat = TaxHelperSvc.vatFromNet(expense.total_net);
				expense.total_gross = TaxHelperSvc.grossFromNet(expense.total_net);
			});
	};

	handlers.uploadFiles = (files, expense) => {
		self.uploadInProgress = true;
		let promises = [];
		let file = files[0];
		promises.push(Upload.upload({
			url: 'api/fees/upload-expense',
			data: {
				file: file
			}
		}));

		self.uploadInProgress = true;
		$q.all(promises)
			.then(function (responses) {
				angular.forEach(responses, function (response) {
					expense.file = response.data.file;
				});
				$timeout(function () {
					self.uploadInProgress = false;
				});
				self.uploadInProgress = false;
			}, function (errors) {
				self.uploadInProgress = false;
				$timeout(function () {
					self.uploadInProgress = false;
				});
			});
	};

	handlers.removeRow = (expense) => {
		self.fee.expenses.splice(self.fee.expenses.indexOf(expense), 1);
	};


	handlers.submitClick = function () {
		let totalNet = 0;
		angular.forEach(self.fee.expenses, (expense) => {
			totalNet += expense.total_net;
		});
		angular.extend(self.fee, {
			total_net_deductions: totalNet,
		});
		$modalInstance.close(self.fee);
	};

}
